import React from "react";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';

import Flex from "../core/Flex";
import Space from "../core/Space";

const FormBigCheckbox2 = ({ children, icon, iconActive, title, maxWidth, active, onClick, flex, ...props }) => {
  return (
    <Checkbox $maxWidth={maxWidth} $active={active} onClick={onClick} $flex={flex === "undefined" ? "unset" : flex} title={title} {...props}>
      <FormBigCheckbox2Title $active={active}>{title}</FormBigCheckbox2Title>
      <Flex justifyContent={"space-between"} alignItems={"flex-start"} style={{ flex: 0 }}>
        {
          active ? iconActive : icon
        }

        {
          active ?
            <img src={`${process.env.PUBLIC_URL}/images/check-filled-white.svg`} style={{ width: 32, height: 32 }} alt={"selected"} />
            :
            <img src={`${process.env.PUBLIC_URL}/images/circle-check.svg`} style={{ width: 32, height: 32 }} alt={"unselected"} />
        }
      </Flex>
    </Checkbox>
  );
};

const Checkbox = styled.button`
  display: flex;
  flex: ${props => props.$flex};
	font: inherit;
  text-align: left;
  background-color: ${props => props.$active ? "var(--aia-bx-blue-2)" : "var(--aia-bx-white)"};
  border: 1px solid var(--aia-bx-blue-2);
  border-radius: 10px;
  padding: 16px;
  cursor: pointer;
  max-width: ${props => props.$maxWidth === "unset" ? "unset" : `${props.$maxWidth}px`};
  transition: all .3s ease;
  -webkit-transition: all .3s ease;
  -moz-transform: all .3s ease;
  align-items: center;
  &:hover {
    background-color: ${props => props.$active ? "var(--aia-bx-blue-6)" : "var(--aia-bx-blue-5)"};
  }
`;

const FormBigCheckbox2Title = styled.h4`
  color: ${props => props.$active ? "var(--aia-bx-white)" : "var(--aia-bx-dark-blue)"};
  font-size: 16px;
  line-height: 26px;
  margin-top: 0;
  margin-bottom: 0;
  flex: 1;
`
const FormBigCheckbox2Divider = styled.div`
  border-bottom: 1px solid ${props => props.$active ? "var(--aia-bx-white)" : "var(--aia-bx-blue-2)"};
`
const FormBigCheckbox2Text = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: ${props => props.$active ? "var(--aia-bx-white)" : "var(--aia-bx-dark-blue)"};
`

Checkbox.defaultProps = {
  $maxWidth: "unset",
  $active: false,
  $flex: "unset",
}

FormBigCheckbox2Title.defaultProps = {
  $active: false
}

FormBigCheckbox2Divider.defaultProps = {
  $active: false
}

export default FormBigCheckbox2;